module.exports = __webpack_public_path__ + "static/media/purpose3.2a894054.svg";